import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { Children, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import VideoTile from './VideoTile';
import VideoTileLocal from './VideoTileLocal';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    height: '100%',
    // backgroundImage: "url('/mac-summit-logo.svg')",
    // backgroundRepeat: 'no-repeat',
    // backgroundPosition: 'center',
  },
  item: {
    position: 'relative',
  },
  chip: {
    position: 'absolute',
    bottom: '0.5rem',
    right: '0.5rem',
    marginLeft: '0.5rem',
    minWidth: '5rem',
    padding: '0.25rem 0.5rem',
    overflow: 'hidden',
    wordBreak: 'break-all',
    opacity: 0.75,
    backgroundColor: '#000a',
    color: 'white',
    fontWeight: '600',
    textShadow: '-2px 1px 0.25em black',
    textAlign: 'center',
    zIndex: '2',
    cursor: 'pointer',
    ...theme.mixins.borderRadius(),
    '&:hover': {
      opacity: 1,
    },
  },
}));

const gridSizes = [
  [100, 100],
  [100, 100],
  [100, 50],
  [50, 50],
  [50, 50],
  [50, 33.3],
  [50, 33.3],
  [50, 25],
  [50, 25],
];

export default function GridView({ children, selectSpeaker, isRecordingUser }) {
  const classes = useStyles();
  const { guestSpeakerId, videoStatus, tileMap, attendeeId, roster } = useSelector(
    ({ video, chime }) => ({
      guestSpeakerId: video.guestSpeakerId,
      tileMap: video.tileMap,
      videoStatus: video.videoStatus,
      attendeeId: chime.attendeeId,
      roster: chime.roster,
    })
  );
  const [items, setItems] = useState([]);
  const hasStream = Children.count(children) > 0;

  const Chip = ({ children }) => <div className={classes.chip}>{children}</div>;
  Chip.propTypes = {
    children: PropTypes.node,
  };

  useEffect(() => {
    const newItems = [];
    for (let rosterUserId in roster) {
      if (tileMap[rosterUserId] !== undefined) {
        const rosterUser = roster[rosterUserId];
        if (!rosterUser.isRecordingUser && rosterUserId !== attendeeId) {
          newItems.push({
            id: rosterUserId,
            name: rosterUser.name,
          });
        }
      }
    }

    if (attendeeId && videoStatus !== 'disabled' && !isRecordingUser) {
      newItems.push({
        id: attendeeId,
        name: roster[attendeeId]?.name,
        isLocal: true,
      });
    }

    setItems(newItems);
    // eslint-disable-next-line
  }, [roster, tileMap, attendeeId, videoStatus, isRecordingUser]);

  let itemWidth, itemHeight, shareHeight;

  if (hasStream) {
    if (items.length > 0) {
      shareHeight = 66.6;
      itemWidth = Math.max(25, Math.min(50, 100 / items.length));
      itemHeight = 100 - shareHeight;
      if (items.length > 2) {
        itemHeight /= 2;
      }
    } else {
      shareHeight = 100;
    }
  } else {
    let gridSizing = gridSizes[items.length] || gridSizes[gridSizes.length - 1];
    itemWidth = gridSizing[0];
    itemHeight = gridSizing[1];
  }

  const tileStyle = {
    width: itemWidth + '%',
    height: itemHeight + '%',
  };

  return (
    <div className={classes.root}>
      {hasStream && (
        <div style={{ width: '100%', height: shareHeight + '%' }} className={classes.item}>
          {children}
        </div>
      )}

      {items.map((video) => {
        const isSelected = guestSpeakerId === video.id;
        const VideoTileClass = video.isLocal ? VideoTileLocal : VideoTile;
        return (
          <div style={tileStyle} key={video.id} className={classes.item}>
            <VideoTileClass
              videoTileId={tileMap[video.id]}
              thisAttendeeId={video.id}
              height={'100%'}
              selectSpeaker={selectSpeaker}
              isSelected={isSelected}
            >
              {video.name && <Chip>{video.name}</Chip>}
            </VideoTileClass>
          </div>
        );
      })}
    </div>
  );
}

GridView.propTypes = {
  selectSpeaker: PropTypes.func,
  children: PropTypes.node,
  isRecordingUser: PropTypes.bool,
};
